// extracted by mini-css-extract-plugin
export default {"container":"folder_container__gyCT8","small":"folder_small__WUvaR","folderIcon":"folder_folderIcon__NZgf5"};